import { StyleProps } from '@summer/jst-react';
import { useTranslate } from 'react-t7e';
import { CleanButton } from 'src/components/common/Button';
import { ChevronBottom } from 'src/components/icons/ChevronBottom';
import { media } from 'src/styles/designs';
import { dirRTL } from 'src/styles/theme';
import styled, { css } from 'styled-components';

export interface ExpandButtonProps {
  active: boolean;
  onClick: () => void;
}

const Button = styled(CleanButton)<{ $active: boolean }>`
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-bottom: 8px;
  svg {
    ${({ $active }) =>
      $active &&
      css`
        transform: rotate(180deg);
      `}
    margin: 0 0 0 7px;
    ${dirRTL} {
      margin: 0 7px 0 0;
    }
  }
  ${dirRTL} {
    margin-left: 0;
    margin-right: auto;
    ${media.w.lessThan.desktop} {
      margin-right: 0;
      margin-left: -20px;
    }
  }
`;

const Text = styled.p`
  color: ${({ theme }) => theme.text.palette.secondary};
  font-size: 14px;
  line-height: 18px;
  text-transform: lowercase;
`;

export const ExpandButton = ({
  active,
  onClick,
  ...props
}: ExpandButtonProps & StyleProps) => {
  const { _ } = useTranslate();

  return (
    <Button $active={active} onClick={onClick} {...props}>
      <Text>{_(active ? 'Read less' : 'Read more')}</Text>
      <ChevronBottom size={13} />
    </Button>
  );
};
